import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=5481ca28&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5481ca28')) {
      api.createRecord('5481ca28', component.options)
    } else {
      api.reload('5481ca28', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=5481ca28&", function () {
      api.rerender('5481ca28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wPGUbINmw0hH/JS/imageCarousel.vue"
export default component.exports